import styled from "@emotion/styled";
import { css, Theme } from "@emotion/react";
import { Fit, RowStack } from "@skbkontur/react-stack-layout";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const TaxRebateLayout = styled.div((props: { width?: string | number }) => ({
    width: props.width ?? "100%",
    display: "inline-block",
}));

export const MenuItemContent = styled(RowStack)({
    maxWidth: 600,
});

export const LawContainer = styled.div(props => ({
    padding: 20,
    width: 216,
    background: theme(props).keyPalette.primaryBackgroundColor,
}));

export const LawNote = styled(Fit)(props => ({
    ...props.theme.candy.typography.smallFont.css(),
    color: props.theme.candy.typography.inactive.color,
}));

export const LawName = styled(Fit)({
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
});

export const LawCaption = styled.div(props => ({
    display: "block",
    fontSize: theme(props).typography.primary.fontSize.css(),
    lineHeight: theme(props).typography.primary.lineHeight.css(),
    minHeight: theme(props).typography.primary.lineHeight.css(),
}));

export const fakeFocus = ({ candy }: Theme) =>
    css({
        borderColor: candy.valueControls.highlightedBorderColor,
        boxShadow: `0 0 0 1px ${candy.valueControls.highlightedBorderColor}`,
        outline: "none",
        zIndex: 2,
    });
